import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Modal, ModalBodyCopy, ModalHeader, ModalButtonContainer } from '@zocdoc/components/src/modal';
import { Button, ButtonGroup } from '@zocdoc/components/src/button';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';

const StyledButtonGroup = styled(ButtonGroup)`
    ${breakpoint.small} {
        display: flex;
    }
`;

export default class ModalView extends Component {
    static propTypes = {
        onShowAction: PropTypes.func,
    };

    static defaultProps = {
        onShowAction: noop,
    };

    componentDidMount() {
        const {
            onShowAction,
        } = this.props;

        onShowAction();
    }

    render() {
        return (
            <Modal onClickCancel={this.props.onClickCancel}>
                <div>
                    <ModalHeader>{this.props.header}</ModalHeader>
                    <ModalBodyCopy>{this.props.message}</ModalBodyCopy>

                    {this.props.additionalMessage
                        ? <ModalBodyCopy>{this.props.additionalMessage}</ModalBodyCopy> : undefined}

                    <ModalButtonContainer>
                        <StyledButtonGroup>
                            <Button
                                data-uem-id="modal-primary-button"
                                fluid
                                href={this.props.primaryActionHref}
                                onClick={this.props.onClickPrimaryAction}
                            >
                                {this.props.primaryActionText}
                            </Button>
                            <Button
                                data-uem-id="modal-secondary-button"
                                fluid
                                onClick={this.props.onClickSecondaryAction}
                                style={Button.STYLE.TRANSPARENT}
                            >
                                {this.props.secondaryActionText}
                            </Button>
                        </StyledButtonGroup>
                    </ModalButtonContainer>
                </div>
            </Modal>
        );
    }
}
